exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aweb[data-v-1ec7cf10]{margin-bottom:1rem}", ""]);

// exports
